export const state = {
  invoices: [],
  invoice_products: [{
    description: '',
    qty: '',
    unit_price: '',
    total_price: ''
  }]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/invoices/state.js